import { subDays } from "date-fns";
import { dateFns } from "utilities";

export const getDateThirtyDaysBeforeToday = (): string => {
  const today = new Date();
  return dateFns.format(subDays(today, 30), "yyyy-MM-dd");
};
